import styled from 'styled-components';
import { Color } from '../../common/base';

const ContractWrapper = styled.div`
  background-color: ${Color.redMediumDark};
  padding: 30px 0;
  color: ${Color.white};
`;

export { ContractWrapper };
